import {ValueObject} from '@s-ui/domain'

export class UpdateInstantOfferSellerRequest extends ValueObject {
  #licensePlate
  #condition
  #zipCode

  constructor({licensePlate, condition, zipCode}) {
    super()
    this.#licensePlate = licensePlate
    this.#condition = condition
    this.#zipCode = zipCode
  }

  static create = ({licensePlate, condition, zipCode}) =>
    new UpdateInstantOfferSellerRequest({licensePlate, condition, zipCode})

  toJSON() {
    const request = {}

    if (this.#licensePlate) {
      request.licensePlate = this.#licensePlate
    }
    if (this.#condition) {
      request.condition = this.#condition
    }
    if (this.#zipCode) {
      request.zipCode = this.#zipCode
    }

    return request
  }
}
